"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotEligibleErrorCodeEnum = void 0;
var NotEligibleErrorCodeEnum;
(function (NotEligibleErrorCodeEnum) {
    NotEligibleErrorCodeEnum[NotEligibleErrorCodeEnum["NO_ERROR"] = -1] = "NO_ERROR";
    NotEligibleErrorCodeEnum[NotEligibleErrorCodeEnum["ERROR_CUSTOMER_NOT_FOUND"] = 1] = "ERROR_CUSTOMER_NOT_FOUND";
    NotEligibleErrorCodeEnum[NotEligibleErrorCodeEnum["ERROR_DATA_UNAVAILABLE"] = 41] = "ERROR_DATA_UNAVAILABLE"; //  code: 41 => message: "Les données de comparaison des voisins sont en cours de préparation."
})(NotEligibleErrorCodeEnum = exports.NotEligibleErrorCodeEnum || (exports.NotEligibleErrorCodeEnum = {}));
